import * as React from "react";
import { Redirect } from "react-router-dom";
import Loader from 'react-loader';
import { toast, ToastContainer } from 'react-toastify';
import { Button, Col, Input, Modal, ModalBody, ModalHeader, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import Collapsible from 'react-collapsible';
import ReactDragList from 'react-drag-list';

import { FormLabel, StyledInput, LargeButton, TextArea, Wrapper, Content, ContentRow } from './SingleLesson.styles';
import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import { PROXIED_MEDIABASE, MEDIABASE } from '../../../../common/constants';
import withServices from '../../../../HOCs/withServices';
import { ContentRowSingleCol } from '../../InteractionSets/InteractionSet/InteractionSet.styles';

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
}

interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
}

class SingleLesson extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            destination: '',
            toLogin: false,
            loaded: true,
            isNavigate: false,
            data: {},
            selectedLesson: '',
        };

        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        this.setTab = this.setTab.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.createScreen = this.createScreen.bind(this);
        this.dragComplete = this.dragComplete.bind(this);
        this.goToEdit = this.goToEdit.bind(this);
        this.goToPreview = this.goToPreview.bind(this);
        this.handleScreenChange = this.handleScreenChange.bind(this);
        this.handleLessonChange = this.handleLessonChange.bind(this);
        this.updateLesson = this.updateLesson.bind(this);
        this.uploadPDF = this.uploadPDF.bind(this);
        this.uploadImages = this.uploadImages.bind(this);
    }

    public onLogout() {
        this.setState({ toLogin: true });
    }

    public handleChange(id, e) {
        console.log(e)
        const data = this.state.data
        data.newScreen[id] = e.target.value;
        this.setState({
            data
        });
    }

    public handleLessonChange(id, e) {
        console.log(e)
        const data = this.state.data
        data.lesson[id] = e.target.value;
        this.setState({
            data
        });
    }


    public onGoBack() {
        const dest = this.props.services.currentBaseUrl + 'lessons';

        console.log(dest);

        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public  goToPreview() {
        const dest = this.props.services.currentBaseUrl + 'lessonpreview/' + this.state.data.lessonID;

        console.log(dest)

        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public goToEdit(data, id) {
        const dest = this.props.services.currentBaseUrl + 'lesson_screens/' + id;

        console.log(dest)

        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public setTab(param, e) {
        const data = this.state.data
        data.activetab = param;
        this.setState({
            data
        });
    }

    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;

        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const { params: { id: lessonID } } = match;

        const [lessonRes, screensRes, setsRes, videosRes] = await Promise.all([adminAPI.getSingleItemGeneral('lessons', lessonID), adminAPI.getLessonScreens(lessonID, true), adminAPI.getInteractionSets(), adminAPI.getVideoAssets()])

        if (lessonRes.ok) {
            const lesson = lessonRes.data;

            const screens = screensRes.data.screens;

            const videos = videosRes.data.assets;

            const sets = setsRes.data;
            console.log(`lesson ${JSON.stringify(lesson, null, 4)}`)
            console.log(`screens ${JSON.stringify(screens, null, 4)}`)
            console.log(`sets ${JSON.stringify(sets, null, 4)}`)
            const screenKeys = {
                id: "id",
                title: "Title",
                type: 'ScreenType'
            }

            const newScreen = {
                DisplayData: {},
                DisplayOrder: 0,
                Title: '',
                Lesson: lessonID,
                ScreenType: 0,
                User: currentUserID,
                VideoUrl: ''
            }

            this.setState(
                {
                    data: {
                        activetab: '1',
                        lesson,
                        lessonID,
                        newScreen,
                        screens,
                        screenKeys,
                        sets,
                        videos
                    }
                }
            )

        } else {
            toast.error('Error fetching Lesson details!');
        }

    }

    public renderOptions(options, idkey, valuekey, labelkey) {
        return (
            options.map(
                (d, i) =>
                    <option key={d[idkey]} value={d[valuekey]}>
                        {d[labelkey]}
                    </option>
            )
        );
    }

    public showContentScreen(data, screen) {
        return (
            <Row>
                <Col lg={8}>
                    <i
                        className="fa fa-align-justify"
                        style={{ cursor: 'pointer', margin: 6 }}
                    />Content
                </Col>
                <Col lg={4}>
                    {/*tslint:disable-next-line jsx-no-lambda*/}
                    <Button onClick={() => this.goToEdit(data, screen.id)} style={{ margin: 6 }}>Edit</Button>

                    {/*tslint:disable-next-line jsx-no-lambda*/}
                    <Button onClick={() => this.screenUpdate(screen)} style={{ cursor: 'pointer', margin: 6 }}>Update</Button>

                    {/*tslint:disable-next-line jsx-no-lambda*/}
                    <Button onClick={() => this.screenDelete(data, screen.id)} style={{ cursor: 'pointer', margin: 6 }}>Delete</Button>
                </Col>
            </Row>
        );
    }

    public showVideoScreen(data, screen) {
        return (
            <Row>
                <Col lg={8}>
                    <i
                        className="fa fa-align-justify"
                        style={{ cursor: 'pointer', margin: 6 }}
                    />Video<br />
                    <video height={250} width={300} controls={true} src={MEDIABASE + "assets/" + screen.VideoUrl} />

                </Col>
                <Col lg={4}>
                    {/*tslint:disable-next-line jsx-no-lambda*/}
                    <Button onClick={() => this.screenUpdate(screen)} style={{ cursor: 'pointer', margin: 6 }}>Update</Button>
                    {/*tslint:disable-next-line jsx-no-lambda*/}
                    <Button onClick={() => this.screenDelete(data, screen.id)} style={{ cursor: 'pointer', margin: 6 }}>Delete</Button>
                </Col>

            </Row>
        );
    }

    public showImageScreen(data, screen) {
        return (
            <Row>
                <Col lg={8}>
                    <i
                        className="fa fa-align-justify"
                        style={{ cursor: 'pointer', margin: 6 }}
                    />Image<br />
                    <img src={MEDIABASE + "assets/" + screen.VideoUrl} style={{ width: '300px' }} />

                </Col>
                <Col lg={4}>
                    {/*tslint:disable-next-line jsx-no-lambda*/}
                    <Button onClick={() => this.screenUpdate(screen)} style={{ cursor: 'pointer', margin: 6 }}>Update</Button>
                    {/*tslint:disable-next-line jsx-no-lambda*/}
                    <Button onClick={() => this.screenDelete(data, screen.id)} style={{ cursor: 'pointer', margin: 6 }}>Delete</Button>
                </Col>

            </Row>
        );
    }

    public showInteractionScreen(data, screen) {
        return (
            <Row>
                <Col lg={8}>
                    <i
                        className="fa fa-align-justify"
                        style={{ cursor: 'pointer', margin: 6 }}
                    />Interaction
                </Col>
                <Col lg={4}>
                    {/*tslint:disable-next-line jsx-no-lambda*/}
                    <Button onClick={() => this.screenUpdate(screen)} style={{ cursor: 'pointer', margin: 6 }}>Update</Button>
                    {/*tslint:disable-next-line jsx-no-lambda*/}
                    <Button onClick={() => this.screenDelete(data, screen.id)} style={{ cursor: 'pointer', margin: 6 }}>Delete</Button>
                </Col>

            </Row>
        );
    }

    public async screenDelete(data, id) {
        console.log("todelete:" + id);

        const retVal = confirm("Do you want to continue ?");

        if (retVal === true) {
            console.log('delete accepted');
            const res = await this.props.services.adminAPI.deleteItemGeneral("lesson_screens", id);
            if (res.ok) {
                toast.success('Deletion Successful');

                const screensRes = await this.props.services.adminAPI.getLessonScreens(data.lessonID);

                if (screensRes.ok) {

                    const screens = screensRes.data.screens;

                    data.screens = screens;

                    this.setState({
                        data,
                        loaded: true
                    });
                }

            }
            else {
                toast.error('Deletion Failed');
            }
            return true;
        } else {
            console.log('delete canceled')
            return false;
        }
    }

    public async screenUpdate(screen) {
        console.log("toupdate:" + screen.id);

        const item = {
            'Title': screen.Title
        }

        const res = await this.props.services.adminAPI.updateScreenPartial(item, screen.id);
        if (res.ok) {
            toast.success('Update Successful');

        }
        else {
            toast.error('Deletion Failed');
        }
    }


    public async updateLesson() {

        const item = this.state.data.lesson;

        const res = await this.props.services.adminAPI.updateItemGeneral('lessons', item, item.LessonId);
        if (res.ok) {
            toast.success('Update Successful');

        }
        else {
            toast.error('Deletion Failed');
        }
    }

    public async createScreen(data, screentype, e) {
        e.preventDefault();
        console.log(screentype);

        this.setState({
            loaded: false
        });

        const item = data.newScreen;

        item.DisplayOrder = data.screens.length;

        if (screentype === 'content') {

            const keybg = 'background';

            item.ScreenType = 0;
            item.DisplayData[keybg] = '#FF6900';
        }
        else if (screentype === 'interaction') {
            item.ScreenType = 1;
        }
        else if (screentype === 'video') {
            item.ScreenType = 2;
        }

        const res = await this.props.services.adminAPI.createItemGeneral('lesson_screens', item);

        if (res.ok) {
            toast.success('Creation Successful');


            const screensRes = await this.props.services.adminAPI.getLessonScreens(data.lessonID);

            if (screensRes.ok) {


                const screens = screensRes.data.screens;

                data.screens = screens;

                this.setState({
                    data,
                    loaded: true
                });
            }
        }
        else {
            toast.error('Creation Failed');
            this.setState({
                loaded: true
            });
        }

    }

    public async dragComplete(e) {
        console.log('darg complete');

        const data = this.state.data

        this.setState({
            loaded: false
        });
        console.log("ScreensAfterDrag: " + JSON.stringify(data.screens, null, 2));


        const item = {
            DisplayItems: JSON.stringify(data.screens),
        }

        const res = await this.props.services.adminAPI.updateLessonScreenOrder(item);

        if (res.ok) {
            toast.success('Update Successful');

            const screensRes = await this.props.services.adminAPI.getLessonScreens(data.lessonID);

            if (screensRes.ok) {

                const screens = screensRes.data.screens;

                data.screens = screens;

                this.setState({
                    data,
                    loaded: true
                });
            }
        }
        else {
            toast.error('Update Failed');
        }
    }

    public handleScreenChange(id, field, e) {
        console.log(e)
        const data = this.state.data
        data.screens[id][field] = e.target.value;
        this.setState({
            data
        });
    }

    public async uploadImages(e) {
        e.preventDefault();

        const data = this.state.data;

        data.uploading = true;

        this.setState({ data });

        const fileInputElement = e.target.elements.upld;
        const formData = new FormData();

        for (const row of fileInputElement.files) {
            formData.append('files', row);
        }

        const res = await this.props.services.adminAPI.updloadLessonImages(formData, data.lessonID)

        if (res.ok) {
            toast.success("Success");

            const screensRes = await this.props.services.adminAPI.getLessonScreens(data.lessonID);

            if (screensRes.ok) {

                const screens = screensRes.data.screens;

                data.screens = screens;

                this.setState({
                    data
                });
            }
        }

        else {
            toast.error("Failed");
        }

        data.uploading = false;

        this.setState({ data });

    }

    public async uploadPDF(e) {
        e.preventDefault();

        const data = this.state.data;

        data.uploading = true;

        this.setState({ data });

        const fileInputElement = e.target.elements.upld;
        const formData = new FormData();

        for (const row of fileInputElement.files) {
            formData.append('files', row);
        }

        const res = await this.props.services.adminAPI.updloadLessonPdf(formData, data.lessonID)

        if (res.ok) {
            toast.success("Success");
        }

        else {
            toast.error("Failed");
        }

        data.uploading = true;

        this.setState({ data });

    }

    public screensDisplay(data) {
        console.log("Screendata: " + data);

        return (
            <ReactDragList
                dataSource={data.screens}
                rowKey="id"
                // tslint:disable-next-line jsx-no-lambda
                row={(screen, index) =>
                    <div key={index} style={{ color: 'black', backgroundColor: 'transparent', border: 'none', margin: 13, padding: 9 }}>

                        <Collapsible trigger={screen[data.screenKeys.title]} key={screen[data.screenKeys.id]}>

                            {
                                screen[data.screenKeys.type] === 0 ? this.showContentScreen(data, screen) :
                                    ""}

                            {
                                screen[data.screenKeys.type] === 1 ? this.showInteractionScreen(data, screen) :
                                    ""}

                            {
                                screen[data.screenKeys.type] === 3 ? this.showImageScreen(data, screen) :
                                    ""}


                            {
                                screen[data.screenKeys.type] === 2 ? this.showVideoScreen(data, screen) :
                                    ""
                            }


                            <StyledInput value={screen[data.screenKeys.title]} onChange={(e) => this.handleScreenChange(index, 'Title', e)} />
                        </Collapsible>

                    </div>

                }
                handles={false}
                className="simple-drag"
                rowClassName="simple-drag-row"
                onUpdate={this.dragComplete}
            />


        );
    }

    public render() {
        const { data } = this.state;
        // console.log("CUrrentData: " + JSON.stringify(data, null, 4));
        if (this.state.toLogin) {
            return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
        }

        if (Object.keys(data).length === 0) {
            return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
                <ToastContainer />
                <Navbar logoutParent={this.onLogout} />
                <Content>
                    <ContentRow className="single-col">
                        <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>

                    </ContentRow>
                </Content>

                <Content>

                    <ContentRowSingleCol>
                        <Nav tabs={true} style={{ flexWrap: 'nowrap' }}>
                            <NavItem >
                                <NavLink onClick={this.setTab.bind(this, '1')}>
                                    Add Content
                            </NavLink>

                            </NavItem>
                            <NavItem >
                                <NavLink onClick={this.setTab.bind(this, '2')}>
                                    Add Interaction
                            </NavLink>
                            </NavItem>
                            <NavItem >
                                <NavLink onClick={this.setTab.bind(this, '3')}>
                                    Add Video
                            </NavLink>
                            </NavItem>

                            <NavItem >
                                <NavLink onClick={this.setTab.bind(this, '4')}>
                                    Upload PDF
                            </NavLink>
                            </NavItem>

                            <NavItem >
                                <NavLink onClick={this.setTab.bind(this, '5')}>
                                    Upload Images
                            </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={data.activetab}>

                            <TabPane tabId="1">
                                <Content >
                                    {/*tslint:disable-next-line jsx-no-lambda*/}
                                    <form className="outlined" onSubmit={(e) => this.createScreen(data, 'content', e)}>

                                        <FormLabel htmlFor="title" style={{ display: 'block' }}>
                                            Title
                                </FormLabel>
                                        {/*tslint:disable-next-line jsx-no-lambda*/}
                                        <TextArea required={true} cols={40} id="title" value={data.newScreen.Title} onChange={(e) => this.handleChange('Title', e)} />

                                        <LargeButton>Submit</LargeButton>
                                    </form>

                                </Content>

                            </TabPane>
                            <TabPane tabId="2">
                                <Content >
                                    {/*tslint:disable-next-line jsx-no-lambda*/}
                                    <form className="outlined" onSubmit={(e) => this.createScreen(data, 'interaction', e)}>

                                        <FormLabel htmlFor="title" style={{ display: 'block' }}>
                                            Title
                                </FormLabel>
                                        {/*tslint:disable-next-line jsx-no-lambda*/}
                                        <TextArea required={true} cols={40} id="title" value={data.newScreen.Title} onChange={(e) => this.handleChange('Title', e)} />

                                        {/*tslint:disable-next-line jsx-no-lambda*/}
                                        <Input required={true} id="intset" type="select" value={data.newScreen.InteractionSet} onChange={(e) => this.handleChange('InteractionSet', e)}>
                                            <option value="">Choose a Set</option>
                                            {this.renderOptions(data.sets, 'id', 'id', 'name')}
                                        </Input>

                                        <LargeButton>Submit</LargeButton>
                                    </form>

                                </Content>

                            </TabPane>
                            <TabPane tabId="3">
                                <Content >
                                    {/*tslint:disable-next-line jsx-no-lambda*/}
                                    <form className="outlined" onSubmit={(e) => this.createScreen(data, 'video', e)}>

                                        <FormLabel htmlFor="title" style={{ display: 'block' }}>
                                            Title
                                </FormLabel>
                                        {/*tslint:disable-next-line jsx-no-lambda*/}
                                        <TextArea required={true} cols={40} id="title" value={data.newScreen.Title} onChange={(e) => this.handleChange('Title', e)} />

                                        {/*tslint:disable-next-line jsx-no-lambda*/}
                                        <Input required={true} id="intset" type="select" value={data.newScreen.VideoUrl} onChange={(e) => this.handleChange('VideoUrl', e)}>
                                            <option value="">Choose a Video</option>
                                            {this.renderOptions(data.videos, 'id', 'FileName', 'Title')}
                                        </Input>

                                        <LargeButton>Submit</LargeButton>
                                    </form>

                                </Content>



                            </TabPane>

                            <TabPane tabId="4">
                                <Content >
                                    <Loader color={'green'} loaded={!data.uploading} />

                                    {/*tslint:disable-next-line jsx-no-lambda*/}
                                    <form className="outlined" onSubmit={(e) => this.uploadPDF(e)}>

                                        <FormLabel htmlFor="upld" style={{ display: 'block' }}>
                                            Upload PDF
                                </FormLabel>

                                        {/*tslint:disable-next-line jsx-no-lambda*/}
                                        <Input required={true} id="upld" type="file" />


                                        <LargeButton>Submit</LargeButton>
                                    </form>

                                </Content>

                            </TabPane>

                            <TabPane tabId="5">
                                <Content >
                                    <Loader color={'green'} loaded={!data.uploading} />
                                    {/*tslint:disable-next-line jsx-no-lambda*/}
                                    <form className="outlined" onSubmit={(e) => this.uploadImages(e)}>

                                        <FormLabel htmlFor="upld" style={{ display: 'block' }}>
                                            Upload Images
                                </FormLabel>

                                        {/*tslint:disable-next-line jsx-no-lambda*/}
                                        <Input required={true} id="upld" type="file" multiple={true} />


                                        <LargeButton>Submit</LargeButton>
                                    </form>

                                </Content>

                            </TabPane>
                        </TabContent>


                    </ContentRowSingleCol>
                    <ContentRow className="single-col">
                        {this.screensDisplay(data)}
                    </ContentRow>

                    <div>
                        <ContentRow>
                            <div>
                                <label htmlFor="title" style={{ display: 'block' }}>
                                    Title
                                </label>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <textarea rows={6} cols={38} id="title" value={data.lesson.Name} onChange={(e) => this.handleLessonChange('Name', e)} />
                            </div>

                            <div>
                                <label htmlFor="desc" style={{ display: 'block' }}>
                                    Description
                                </label>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <textarea rows={6} cols={38} id="desc" value={data.lesson.Description} onChange={(e) => this.handleLessonChange('Description', e)} />
                            </div>

                            <div>
                                <Button onClick={this.updateLesson}>
                                    Update
                                </Button>
                            </div>

                        </ContentRow>


                    </div>

                    <LargeButton onClick={this.goToPreview}>Preview</LargeButton>

                </Content>
            </Wrapper>

        );
    }
}

export default withServices(SingleLesson);


// WEBPACK FOOTER //
// ./src/pages/Admin/Lessons/SingleLesson/SingleLesson.tsx